import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Mission from "@/components/sections/Mission";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import ServiceArea from "@/components/sections/ServiceArea";
import ContactSection from "@/components/sections/ContactSection";

export default function Home() {
    return (
        <div data-testid="home-page" className="min-h-screen bg-brand-paper">
            <Navbar />
            <main>
                <Hero />
                <Mission />
                <About />
                <Services />
                <ServiceArea />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
}
